export const SET_DIALOG = 'SET_DIALOG';
